<template>
    <div
        role="button"
        class="mx-[5px] flex h-8 cursor-pointer select-none items-center justify-between gap-1.5 rounded-[4px] bg-red-50 pl-2 pr-1.5 transition duration-100 ease-in-out hover:bg-red-100/70"
        :data-testid="'promo-node-' + name"
    >
        <div class="flex min-w-0 items-center gap-1.5">
            <img :src="promo.logo" class="h-4 w-4 shrink-0" alt="" />

            <span class="truncate text-xs font-medium text-gray-700">
                {{ name }}
            </span>
        </div>

        <span
            class="shrink-0 rounded-[4px] bg-orange-500 px-1.5 py-0.5 text-[11px] font-medium leading-normal text-gray-700"
        >
            {{ promo.actionLabel }}
        </span>
    </div>
</template>

<script lang="ts" setup>
import { PropType, onMounted } from 'vue';

import { IActionPromo } from '@/types/Atomic/IActions';

const props = defineProps({
    name: {
        type: String,
        required: true,
    },
    promo: {
        type: Object as PropType<IActionPromo>,
        required: true,
    },
});

onMounted(() => {
    props.promo.onShown?.();
});
</script>
